export default __webpack_public_path__ + "static/media/Theme17.89938cb6.png";